export default {
	coachPurple: '#6e16aa',
	coachPurpleHover: '#621299',
	black: '#0b1b17',
	nrlGreen: '#00ff9a',
	nrlGreenHover: '#05e58d',
	nrlDarkGreen: '#003A31',
	nrlDarkGreenHover: '#003129',
	red: '#d0011b',
	orange: '#ef7d3c',
	blue: '#57abde',
	green: '#00B700',
	liveGreen: '#7ED321',
	lightGreen: '#e5ebea',
	darkGrey: '#777777',
	grey: '#959595',
	silver_grey: '#F1F1F1',
	lightGrey: '#f6f6f6',
	title: '#0B1C17',
	coach_value: '#7E2FB3',
	negative_value: '#D0021B',
	form_border: '#C0C0C0',
	footer_background: '#0B1C17',
	toggle_background: '#C0C0C0',
	icon_grey: '#C0C0C0',
	captain: "#EF7D3C",
	vice_captain: "#57ABDE",
	emergency: "#B55DAE",
	emergency_active: "#FC5B59",
	active_stats: "#e6ebea",
	round_selector_item: '#A3AAB2',
	box_shadow: '0 0 10px 0 rgba(0,0,0,0.15)',
	coach_poup_body_text: '#4A4A4A'
};


// WEBPACK FOOTER //
// ./src/assets/css/colors.js